var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"excel-import",attrs:{"id":"div-with-loading"}},[_c('upload-file',{ref:"uploadFile",attrs:{"accept-ext":['.xlsx', '.xls', '.csv']},on:{"file":_vm.uploadFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }